import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchHighlight',
    standalone: false
})
export class HighlightSearchPipe implements PipeTransform {
  transform(text: string, match?: string): string {
    if (!text || !match) {
      return text;
    }

    const sanitizedMatch = match.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const regex = new RegExp(sanitizedMatch, 'gi');
    return text.replace(regex, `<span class="highlight">$&</span>`);

  }
}

